module.exports = __webpack_public_path__ + "static/equity-2466dab7af2778aa9958506640282050.mp4";